import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26a68a9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claim-address-input" }
const _hoisted_2 = { class: "claim-address-input__info" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "claim-address-input__info-icon"
}
const _hoisted_5 = { class: "claim-address-input__info-name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "claim-address-input__title" }, "Ethereum presale address", -1))

import { Account } from "@/types/account";
import { PropType, ref, computed, ComponentPublicInstance } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'claim-address-input',
  props: {
  account: {
    type: Object as PropType<Account | null>,
    default: null,
  },
  value: {
    type: String,
    default: () => {
      return "";
    },
  },
},
  emits: ["update:address"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const inputRef = ref<ComponentPublicInstance<HTMLInputElement>>();
__expose({ inputRef });





const textValue = computed({
  get: () => props.value,
  set: (value) => emit("update:address", value),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.account)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.account.image
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          ref_key: "inputRef",
          ref: inputRef,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textValue).value = $event)),
          type: "text",
          class: "claim-address-input__input",
          placeholder: "0x… address"
        }, null, 512), [
          [_vModelText, textValue.value]
        ])
      ])
    ])
  ]))
}
}

})